<template>
    <div>
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-video-camera"></i> 站点详情
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-descriptions title="站点信息" :column="5" border>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-s-order"></i>
                        站点名称
                    </template>
                    1号位
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-location"></i>
                        站点地址
                    </template>
                    陕西省西安市新城区长缨西路104号
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-timer"></i>
                        创建时间
                    </template>
                    2022-08-07 08:24:37
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-s-marketing"></i>
                        站点状态
                    </template>
                    <el-tag color="#ffffff" type="success">正常</el-tag>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-s-marketing"></i>
                        操作
                    </template>
                    <el-button type="primary" plain size="mini">编辑</el-button>
                    <el-button type="primary" plain size="mini">关联设备</el-button>
                    <el-button type="danger" plain size="mini">删除</el-button>
                </el-descriptions-item>
            </el-descriptions>

            <el-descriptions class="margin-top" title="关联设备" :column="5" border>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-s-order"></i>
                        设备ID
                    </template>
                    SD20220129
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-location"></i>
                        设备地址
                    </template>
                    陕西省西安市新城区西一路242号
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-s-marketing"></i>
                        设备状态
                    </template>
                    <el-tag color="#ffffff" type="success">正常</el-tag>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-s-data"></i>
                        当前水位/米
                    </template>
                    0.5
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-menu"></i>
                        操作
                    </template>
                    <el-button type="primary" plain size="mini">查看设备</el-button>
                    <el-button type="danger" plain size="mini">删除</el-button>
                </el-descriptions-item>

                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-s-order"></i>
                        设备ID
                    </template>
                    SD20220133
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-location"></i>
                        设备地址
                    </template>
                    陕西省西安市新城区金吾丈西路
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-s-marketing"></i>
                        设备状态
                    </template>
                    <el-tag color="#ffffff" type="success">正常</el-tag>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-s-data"></i>
                        当前水位/米
                    </template>
                    0.6
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-menu"></i>
                        操作
                    </template>
                    <el-button type="primary" plain size="mini">查看设备</el-button>
                    <el-button type="danger" plain size="mini">删除</el-button>
                </el-descriptions-item>

                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-s-order"></i>
                        设备ID
                    </template>
                    SD20220115
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-location"></i>
                        设备地址
                    </template>
                    陕西省西安市灞桥区桃花潭人行天桥
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-s-marketing"></i>
                        设备状态
                    </template>
                    <el-tag color="#ffffff" type="success">正常</el-tag>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-s-data"></i>
                        当前水位/米
                    </template>
                    0.5
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <i class="el-icon-menu"></i>
                        操作
                    </template>
                    <el-button type="primary" plain size="mini">查看设备</el-button>
                    <el-button type="danger" plain size="mini">删除</el-button>
                </el-descriptions-item>
            </el-descriptions>

            <el-descriptions class="margin-top" title="实时视频" :column="4" border></el-descriptions>
            <img src="../../assets/img/dd1.png" alt="asd" />

            <el-descriptions class="margin-top" title="数据分析" :column="4" border></el-descriptions>
            <div class="detaFilter">
                <el-date-picker
                    v-model="dateValue"
                    type="daterange"
                    align="right"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    :picker-options="pickerOptions"
                ></el-date-picker>
                <el-button type="primary" class="llll">查询</el-button>
                <el-button type="primary">刷新</el-button>
                <el-button type="primary">导出</el-button>
            </div>
            <div class="one" id="one" ref="one"></div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            dateSelectValue: '',
            dateSelectOptions: [
                {
                    value: '设备信息上报',
                    label: '设备信息上报'
                },
                {
                    value: '业务数据上报',
                    label: '业务数据上报'
                },
                {
                    value: '报警',
                    label: '报警'
                },
                {
                    value: '故障',
                    label: '故障'
                }
            ],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                            picker.$emit('pick', [start, end]);
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date();
                            const start = new Date();
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                            picker.$emit('pick', [start, end]);
                        }
                    }
                ]
            },
            dateValue: ''
        };
    },
    mounted(){
        setTimeout(() => {
             let one = this.$echarts.init(this.$refs.one);
            one.setOption({
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    bottom: 25
                },
                toolbox: {
                    feature: {
                        saveAsImage: {}
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['9-5 00:00','9-5 01:00','9-5 02:00','9-5 03:00','9-5 04:00','9-5 05:00','9-5 06:00','9-5 07:00','9-5 08:00','9-5 09:00','9-5 10:00','9-5 11:00','9-5 12:00','9-5 13:00','9-5 14:00','9-5 15:00','9-5 16:00','9-5 17:00','9-5 18:00','9-5 19:00','9-5 20:00','9-5 21:00','9-5 22:00','9-5 23:00'],
                    textStyle: {
                        color: '#000000'
                    }
                },
                yAxis: {
                    type: 'value'
                },
                series: [{
                    data:[1.5,1.1,1.4,1.3,1.2,1.8,1.5,1.5,1.5,1.4,1.4,1.5,1.4,1.3,1.6,1.5,1.6,1.2,1.3,1.5,1.5,1.8,1.3],
                    name:'SD20220129 水位/米',
                    type:"line",
                    itemStyle:{
                        color:"#73c0de"
                    }
                },{
                    data:[1.2,1.2,1.3,1.2,1.3,1.2,1.2,1.3,1.3,1.3,1.3,1.5,1.4,1.3,1.3,1.5,1.6,1.2,1.5,1.2,1.5,1.4,1.3],
                    name:'SD20220133 水位/米',
                    type:"line",
                    itemStyle:{
                        color:"#9a60b4"
                    }
                },{
                    data:[1.8,1.5,1.7,1.1,1.1,1.1,1.6,1.2,1.2,1.4,1.5,1.5,1.4,1.3,1.6,1.5,1.3,1.2,1.5,1.5,1.5,1.1,1.1],
                    name:'SD20220115 水位/米',
                    type:"line",
                    itemStyle:{
                        color:"#5470c6"
                    }
                }]
            });
        }, 1000);
    },
};
</script>

<style scoped>
.margin-top {
    margin-top: 20px;
}
.deviceDetail {
    color: cornflowerblue;
}
.detaFilter{
    margin-top: -20px;
}
.one {
    width: 100%;
    height: 400px;
}
.llll{
    margin-left: 10px;
}
</style>